import { Box, Text, Link, Center, Heading, Divider } from '@chakra-ui/react'
import { buildSearchUrl } from '@!/Util'
import { ShareButtons } from '@!/Store/Common/components/ShareButtons'

export const BookExpandedInfo = ({ book }) => {
  return (
    <Box w="100%">
      <Divider my="3" />
      <Center>
        <Heading as="h2" fontSize="md" fontWeight="semibold">
          詳細情報
        </Heading>
      </Center>
      {book.title_name && (
        <Box mt={2}>
          <Text fontSize="2xs">タイトル：{book.title_name}</Text>
        </Box>
      )}
      {book.author_name && (
        <Box mt={2}>
          <Text fontSize="2xs">
            著者名：
            {book.author_name
              .split(',')
              .map((author, index) => (
                <Link key={index} textDecoration="none" href={buildSearchUrl('author', author)}>
                  {author}
                </Link>
              ))
              .reduce((acc, curr) => [acc, ', ', curr])}
          </Text>
        </Box>
      )}
      {book.publisher_name && (
        <Box mt={2}>
          <Text fontSize="2xs">
            出版社：
            <Link textDecoration="none" href={buildSearchUrl('publisher', book.publisher_name)}>
              {book.publisher_name}
            </Link>
          </Text>
        </Box>
      )}
      {book.magazine_name && (
        <Box mt={2}>
          <Text fontSize="2xs">
            連載雑誌：
            <Link textDecoration="none" href={buildSearchUrl('magazine', book.magazine_name)}>
              {book.magazine_name}
            </Link>
          </Text>
        </Box>
      )}
      {book.sub_genre_names && (
        <Box mt={2}>
          <Text fontSize="2xs">
            ジャンル：
            {book.sub_genre_names
              .map((genre) => (
                <Link key={genre} textDecoration="none" href={buildSearchUrl('category', genre)}>
                  {genre}
                </Link>
              ))
              .reduce((acc, curr) => [acc, ', ', curr])}
          </Text>
        </Box>
      )}
      <Center mt={3} mb={1}>
        <ShareButtons title={`${book.title_name}(${book.volume})`} />
      </Center>
      <Divider mt="3" />
    </Box>
  )
}
